import React, { Component } from 'react';
import './styles.scss';

export default class Anchor extends Component {
    render () {
        const { className, colorIndex, size } = this.props;

        let disabledClass = this.props.disabled ? "disabled" : "";
        let finalClassName = "Anchor " + disabledClass;


        


        let icon=null;
        let label=null;

        if (this.props.icon) {icon = this.props.icon};
        if (this.props.label) {label = this.props.label};

        return (
            <a {...this.props} className={finalClassName}>{icon}<span className="label">{label}</span></a>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UIKit/Anchor/index.js